<template>
  <div class="container">
    <mt-header class="header" title="充值">
      <header-item slot="left" v-bind:isBack=true v-on:onclick="leftClick">
      </header-item>    
    </mt-header>
    <div class="top-wrapper">
      <div class="row-wrapper title-wrapper">
        <img class="icon" src="../../assets/image/change-icon/b10_order@2x.png" />
        <label class="title">请选择充值方式</label>        
      </div>
      <div class="row-wrapper title-wrapper" style="margin-left: 10px;margin-right: 10px;">
        <mt-field label="金额:" placeholder="请输入充值金额" type="number"  v-model="cash"></mt-field>
      </div>      
    </div>
    <div class="item-wrapper" v-on:click="payType(item.code)" v-for="item in payList" v-if="!teegon && item.code != 'balance'">
      <div class="item-left-wrapper">
        <img v-if="item.code == 'alipay.wap'" class="icon" src="../../assets/image/change-icon/e2_icon_alipay@2x.png" />
        <img v-if="item.code == 'unionpay.app'" class="icon" src="../../assets/image/change-icon/e2_icon_tiangong@2x.png" />
        <img v-if="item.code == 'wxpay.web'" class="icon" src="../../assets/image/change-icon/e2_icon_wechat@2x.png" />
        <img v-if="item.code == 'wxpay.h5'" class="icon" src="../../assets/image/change-icon/e2_icon_wechat@2x.png" />
        <img v-if="item.code == 'teegon.wap'" class="icon" src="../../assets/image/change-icon/e2_icon_wechat@2x.png" />
        <img v-if="item.code == 'balance'" class="icon" src="../../assets/image/change-icon/e2_icon_tiangong@2x.png" />
        <label class="item-title">{{item.name}}</label>  
      </div>
      <div class="item-right-wrapper">
        <img v-if="code == 'alipay.wap' && item.code == 'alipay.wap'" class="item-select" src="../../assets/image/change-icon/b1_icon-checkmark.png">   
        <img v-if="code == 'unionpay.app' && item.code == 'unionpay.app'" class="item-select" src="../../assets/image/change-icon/b1_icon-checkmark.png"> 
        <img v-if="code == 'wxpay.web' && item.code == 'wxpay.web'" class="item-select" src="../../assets/image/change-icon/b1_icon-checkmark.png"> 
        <img v-if="code == 'wxpay.h5' && item.code == 'wxpay.h5'" class="item-select" src="../../assets/image/change-icon/b1_icon-checkmark.png"> 
        <img v-if="code == 'teegon.wap' && item.code == 'teegon.wap'" class="item-select" src="../../assets/image/change-icon/b1_icon-checkmark.png"> 
        <!-- <div class="password-wrapper" v-if="code == 'balance' && item.code == 'balance'">
          <div class="input-wrapper">
            <img src="../../assets/image/change-icon/a0_key@2x.png"/>
            <input type="password" class="bottom-input" v-model="password" placeholder="请输入登录密码" maxlength="26">
            <img v-if="code == 'balance' && item.code == 'balance'" class="item-select" src="../../assets/image/change-icon/b1_icon-checkmark.png">                
          </div>
        </div> -->
      </div>      
    </div>
    <div class="item-wrapper" v-on:click="payType('wxpay_jsapi')"  v-if="teegon">
      <div class="item-left-wrapper">
        <img class="icon" src="../../assets/image/change-icon/e2_icon_wechat@2x.png" />
        <label class="item-title">微信支付</label>       
      </div>
      <div class="item-right-wrapper">
        <img v-if="type == 'wxpay_jsapi'" class="item-select" src="../../assets/image/change-icon/b1_icon-checkmark.png">         
      </div>      
    </div>
    <div class="action-wrapper">
      <gk-button class="button" type="primary" v-on:click="pay">立即充值</gk-button>
    </div>
  </div>
</template>

<script>
import { HeaderItem, Button } from '../../components/common'
import { mapState, mapActions } from 'vuex'
import { Header, MessageBox, Indicator, Toast } from 'mint-ui'
import { recharge, paymentTypesList } from '../../api/payment'
import { ENUM } from '../../const/enum'
import { configGet } from '../../api/config'
import XXTEA from '../../assets/js/xxtea'
import wx from 'weixin-js-sdk'

export default {
  data() {
    return {
      payList: this.payList,
      alipay_html: this.alipay_html,
      config: this.config,
      code: this.code,
      type: this.type,
      password:this.password,
      teegon: false,
      cash:null,
      openid:null,
      referer:null,
    }
  },
  props: {
    order: {
      type: Object,
    }
  },
  mounted(){
    paymentTypesList().then(
      (response) => {
        this.payList = response.payment_types;
        this.payType(this.payList[0].code)
      }, (error) => {
        Indicator.close()
      }),
    this.$on('onPayFailed', ( event,reason ) => {
      let orderid = this.$route.query.order;

      let orderType = this.$cookie.get('orderType');
      if(orderType && orderType ==2){
        this.$router.push({ name: 'scanOrderDetail', query: {id: orderId, isFromPay: true }}) 
      }else{
        this.$router.push({ name: 'orderDetail', query: {id: orderId, isFromPay: true }}) 
      }
    }),
    this.$on('onPaySuccess', ( event,reason ) => {
      this.goPaySucceed();
    })
  },
  computed: {
    getOrderAmount: function () {
      let total = this.$route.query.total;
      return (total) ? total : ''
    }
  },
  methods: {
    ...mapActions({
      fetchHomeBanner: 'fetchHomeBanner',
      fetchHomeProduct: 'fetchHomeProduct',
      fetchConfig: 'fetchConfig'
    }),
    leftClick() {
      this.$router.go(-1)
    },
    /*
    *获取支付方式
    */ 
    payType(code) {
      if(code == 'wxpay_jsapi' || code == 'wxpay.h5') {
        this.type = code;
        if(code == 'wxpay.h5'){
          this.code = code;
        }
      } else {
        this.code = code;
      }
    }, 
    /*
    *支付
    */ 
    pay() {
      let code = this.code;
      let type = this.type;
      let cash = this.cash;
      let referer = null;
      let channel = null;
      let openid = null;
      if(this.teegon == false) {
        if(code == 'teegon.wap') {
          this.teegon = true;
          return;
        }
      }
      if(code == 'alipay.wap' || type == 'wxpay_jsapi' || type == 'wxpay.h5') {
        let order = this.$route.query.order;
        referer = window.location.protocol + "//" + window.location.host + window.location.pathname + '#/paySucceed?order='+orderid;
      };

      if(type == 'wxpay_jsapi') {
        channel = "wxpay_jsapi"
      };
      if(type == 'wxpay.h5') {
        channel = "wxpay.h5"
      };

      if(!cash || cash<=0){
        Toast('请输入充值金额');
        return
      }
      if(!code) {
        Toast('请选择支付方式');
        return
      }
      if(code == 'teegon.wap') {
        if(!type) {
          Toast('请选择支付方式');
          return
        }
      }

      if (cash) {
        // 微信支付
        if(code == 'wxpay.web') {
          this.fetchConfig().then(response => {
            let wechat = response.config['wxpay.web'];
            let openid = this.$cookie.get('o');
            let that = this;
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: wechat.app_id, // 必填，公众号的唯一标识
              timestamp: wechat.timestamp, // 必填，生成签名的时间戳
              nonceStr: wechat.nonceStr, // 必填，生成签名的随机串
              signature: wechat.signature,// 必填，签名，见附录1
              jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            wx.error(function(res){
                // config信息验证失败会执行error函数，如签名过期导致验证失败，
                //具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                console.error(res)
            });
            wx.ready(function() {
               recharge(cash, code, referer, channel, openid).then(
                (ressponse) => {
                  if(ressponse && ressponse.wxpay){
                    var result = ressponse;
                    that.$cookie.set('cash',cash);
                    return wx.chooseWXPay({
                        timestamp: result.wxpay.timestamp.toString(), // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                        nonceStr: result.wxpay.nonce_str, // 支付签名随机串，不长于 32 位
                        package: result.wxpay.packages, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                        signType: 'MD5', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                        paySign: result.wxpay.sign, // 支付签名
                        success: function (res) {
                            if(res.errMsg == "chooseWXPay:ok"){
                                that.$emit('onPaySuccess', res.errMsg);
                            }
                            else{
                                that.$emit('onPayFailed', res.errMsg);
                            }
                            // 支付成功后的回调函数
                            return true;
                        },
                        cancel: res => {
                          //支付取消
                          that.$emit('onPayFailed', '1');
                        },
                        // 支付失败回调函数
                        fail: function(res){
                            that.$emit('onPayFailed', res.errMsg);
                        }
                    });
                  }
                  else{
                    return false;
                  }
                },
                (error) => {
                  Toast(error.errorMsg);
                  console.dir(error)
                })
            });
          });
        }
        //支付宝支付
        if(code == 'alipay.wap' || type == 'wxpay_jsapi' || type == 'wxpay.h5') {
          recharge(cash, code, referer, channel, openid).then(
          (response) => {
            if(response) {
              if(code == 'alipay.wap') {
                if ( response.alipay && response.alipay.html  ) {
                  this.alipay_html = response.alipay.html;
                  if(this.alipay_html != '') {
                    const div = document.createElement('div');
                    div.innerHTML = this.alipay_html;
                    document.body.appendChild(div);
                    document.forms[0].submit();
                  }
                }
              }
              if(type == 'wxpay_jsapi') {
                if ( response.teegon && response.teegon.url  ) {
                  window.location.href = response.teegon.url;
                }
              };
              if(type == 'wxpay.h5') {
                if(response.result && response.result.mweb_url  ) {
                  window.location.href = response.result.mweb_url;
                }
              };
              if(code == 'balance') {
                this.goPaySucceed();
              };
            }
          }, (error) => {
            Toast(error.errorMsg);
            console.dir(error)
            // Toast('请求异常:'+error.errorMsg)
          })
        }
        //余额支付
        // if(code == 'balance' ) {
        //     if(this.password == undefined || this.password ==null ||  this.password.length < 6){
        //       Toast('密码长度不能小于6位')
        //       return false
        //     }
        //     recharge(cash, code, referer, channel, openid, this.password).then(
        //       (response) => {
        //         if(response) {
        //           this.goPaySucceed();
        //         }
        //       }, (error) => {
        //         Toast('请求异常:'+error.errorMsg)
        //     })
        // }
      }
    },
    /*
     * 微信支付
     */
    weixiPay(config) {
      if(config.prepay_id) {
        config.prepay_id = 'prepay_id=' + config.prepay_id
      }
      this.wxApi.wxRegister(config);
    },
    goPaySucceed() {
      let order = this.$route.query.order
      this.$cookie.set('orderid',order)
      this.$router.push({ name: 'paySucceed', params: { order: order }, query:{ order: order }})
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    background-color: $mainbgColor;
    .password-wrapper {
      .input-wrapper {
        display: flex;
        align-content: center;
        align-items: center;
        background-color: #fff;
        height: 44px;
        .item-select {
          width: 16px;
          height: 16px;
          margin-right: 22px;
        }
        input {
          @include input;
          flex: 1;
          height: 40px;
          line-height: 40px;
        }
        .bottom-input {
          border-bottom-width: 0px;
        }
      }
    }
  }
  .header {
    @include header;
    border-bottom: 1px solid $lineColor;
  }
  .top-wrapper {
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    background-color: #fff;
    margin-bottom: 15px;
  }
  .row-wrapper {    
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .title-wrapper {
    height: 64px;
  }
  .subtitle-wrapper {
    height: 30px;
    margin-top: 10px;
  }
  .icon {
    width: 18px;
    height: 18px;
    margin-left: 16px;
    margin-right: 10px;
  }
  .title {
    font-size: 16px;
    color: #3C3C3C;    
  }
  .subtitle {
    font-size: 16px;
    color: #4D4D4D; 
    margin-left: 50px; 
  }
  .price {
    font-size: 16px;
    color: $primaryColor;    
  }
  .item-wrapper{ 
    height: 62px;  
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background-color: #fff;
    border-bottom: 1px solid $lineColor; 
  }
  .item-wrapper {    
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
    background-color: #fff;
  }
  .item-left-wrapper {  
    flex: 1;  
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .item-right-wrapper {
    flex: 1;    
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
  .item-title {
    font-size: 16px;
    color: #3C3C3C;
  }  
  .item-subtitle {
    font-size: 16px;
    color: #8C8C8C;
    margin-right: 5px;
    text-align: right;
  }
  .item-select {
    width: 16px;
    height: 16px;
    margin-right: 22px;
  }
  .indicator {
    width: 14px;
    height: 14px;
    margin-left: 5px;
    margin-right: 16px;      
  }
  .action-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 50px;
    margin-top: 45px;
  }
  .button { 
    @include button;  
    width: 180px;
    height: 50px;
  }
</style>





// WEBPACK FOOTER //
// src/page/balance/recharge.vue